import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Image } from 'react-bootstrap';
import { getPortraitResponse } from '../../utils/GraphUtils';

var Portrait = function Portrait(props) {
  var _useMsal = useMsal(),
      instance = _useMsal.instance;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      imageSrc = _useState2[0],
      setImageSrc = _useState2[1];

  var username = props.username;
  useEffect(function () {
    var getPortrait = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPortraitResponse(instance, username);

              case 2:
                response = _context.sent;

                if (!response) {
                  _context.next = 15;
                  break;
                }

                if (!(response.status !== 200)) {
                  _context.next = 8;
                  break;
                }

                setImageSrc(require('../../../assets/images/default-profile.svg'));
                _context.next = 15;
                break;

              case 8:
                _context.t0 = setImageSrc;
                _context.t1 = URL;
                _context.next = 12;
                return response.blob();

              case 12:
                _context.t2 = _context.sent;
                _context.t3 = _context.t1.createObjectURL.call(_context.t1, _context.t2);
                (0, _context.t0)(_context.t3);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPortrait() {
        return _ref.apply(this, arguments);
      };
    }();

    getPortrait();
  }, []);

  if (!imageSrc) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    src: imageSrc
  }));
};

export default Portrait;